export function formatTelefone(telefone) {
    const numeros = telefone.replace(/\D/g, '');

    const semDDI = numeros.startsWith('55') && numeros.length > 11
        ? numeros.slice(2)
        : numeros;

    if (semDDI.length === 11) {
        return semDDI.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    if (semDDI.length === 10) {
        return semDDI.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    return telefone;
}
